import { Box, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { ReactNode } from "react";
import { cn } from "utils/cn";

type PanelVariants = "light" | "dark";

interface TwoPanelViewProps {
  pageHeader?: string | JSX.Element | ReactNode;
  pageSubheader?: string | JSX.Element | ReactNode;

  // left panel 
  leftPanelHeader?: string | JSX.Element | ReactNode;
  leftPanelSubheader?: string | JSX.Element | ReactNode;
  LeftPanelContent: JSX.Element | ReactNode;
  leftPanelVariant?: PanelVariants;

  // right panel 
  rightPanelHeader?: string | JSX.Element | ReactNode;
  rightPanelSubheader?: string | JSX.Element | ReactNode;
  RightPanelContent: JSX.Element | ReactNode;
  rightPanelVariant?: PanelVariants;
}

const TwoPanelView = ({
  leftPanelHeader, rightPanelHeader,
  leftPanelSubheader, rightPanelSubheader,
  LeftPanelContent, RightPanelContent,
  leftPanelVariant = "dark", rightPanelVariant = "light",
}: TwoPanelViewProps) => {
  const panelVariants = {
    dark: "FN-panel-dark",
    light: "FN-panel-light",
  };

  return (
    <div className="px-5">
      <div className="max-w-full grid grid-cols-12 pt-4">
        <div className={cn(
          "mr-[10px] col-span-6",
          panelVariants[leftPanelVariant]
        )}>
          {leftPanelHeader && <h4 className="font-semibold text-xl break-words overflow-hidden">{leftPanelHeader}</h4>}
          {leftPanelSubheader && <h5 className="text-xs ">{leftPanelSubheader}</h5>}
          {LeftPanelContent}
        </div>

        <div className={cn(
          "ml-[10px] col-span-6",
          panelVariants[rightPanelVariant]
        )}>
          <h4 className="font-semibold text-xl break-words overflow-hidden">{rightPanelHeader}</h4>
          <h5 className="text-xs break-words overflow-hidden">{rightPanelSubheader}</h5>
          {RightPanelContent}
        </div>
      </div>
    </div>
  );
};

export default TwoPanelView;